module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-5-fill-f892201c.svg";